import { type RouteRecordRaw } from "vue-router";
import { type MjfRouteMeta, RouteNames } from "@shared/types/localTypes/router";

export default {
  path: "/marketplace",
  children: [
    {
      path: "purchase",
      name: RouteNames.MarketplacePurchase,
      component: () => import("@/views/marketplace/MarketplacePurchase.vue"),
      meta: { autoLogout: true } as MjfRouteMeta,
    },
  ],
} as RouteRecordRaw;
